export default __webpack_public_path__ + "static/media/logoLogin.1b85db39.svg";